import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Admin / HR Pages
import AdminLayout from './Pages/AdminLayout';
import RecruitmentDashboard from './Pages/RecruitmentDashboard';
import JobPost from './Pages/JobPost';
import JobApplicants from './Pages/JobApplicants';
import Score from './Pages/Score';
import SendOffer from './Pages/SendOffer';
import AssessmentManager from './Pages/AssessmentManager';
import PersonalDocuments from './Pages/PersonalDocuments';
import EmployeeJourney from './Pages/EmployeeJourney';
import EmployeeLetters from './Pages/EmployeeLetters';
import EmployeeResignation from './Pages/EmployeeResignation';
import Sidebar from './Pages/Sidebar';
import PostNewJob from './Pages/PostNewJob';
import NewAssessment from './Pages/NewAssessment';
import SelectedCandidates from './Pages/SelectedCandidates';
import RejectedCandidates from './Pages/RejectedCandidates';
import ScheduleInterviews from './Pages/ScheduleInterviews';
import JobPositionsStatus from './Pages/JobPositionsStatus';
import AllMedicalCertificate from './Pages/AllMedicalCertificate';
import AcceptanceLetter from './Pages/AcceptanceLetter';
import ShortJobs from './Pages/ShortJobs';
import PostedShortJobs from './Pages/PostedShortJobs';
import ShortJobApplicants from './Pages/ShortJobApplicants';
import Events from './Pages/Events';


// Candidate Pages
import CandidateLogin from './Pages/CandidateLogin';
import CandidateRegister from './Pages/CandidateRegister';
import EmailVerification from './Pages/EmailVerification';
import CandidateLayout from './Pages/CandidateLayout';
import CandidateDashboard from './Pages/CandidateDashboard';
import AppliedJobs from './Pages/AppliedJobs';
import AllJobs from './Pages/AllJobs';
import Interview from './Pages/Interview';
import MyJobs from './Pages/MyJobs';
import Letters from './Pages/Letters';
import CandidateDocuments from './Pages/CandidateDocuments';
import CandidatePersonalDocuments from './Pages/CandidatePersonalDocuments';
import Agreements from './Pages/Agreements';
import MedicalCertificate from './Pages/MedicalCertificate';
// Shared / Other Pages
import ApplyingJob from './Pages/ApplyingJob';
import TakeAssessment from './Pages/TakeAssessment';
import JobDetails from './Pages/JobDetails';
import SavedJobs from './Pages/SavedJobs';
import Jobs from './Pages/Jobs';
import AboutCompany from './Pages/AboutCompany';
import ClientLogin from './Pages/ClientLogin';
import MyWallet from './Pages/MyWallet';
import MyReferral from './Pages/MyReferral';
import SpecialOffers from './Pages/SpecialOffers';
import { ToastProvider } from './context/ToastContext';
import CandidateWallet from './Pages/CandidateWallet';
import './index.css';
import Dashboard from "./Pages/Dashboard"
import Adminsidebar from './Pages/AdminSidebar';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsAndConditions from './Pages/TermsAndConditions';
import PageAccess from './Pages/PageAccess';
import AdminEmployeeReferral from './Pages/AdminEmployeeReferral';
import Attendancelist from './Pages/AttendanceList';


function App() {
  return (
   <ToastProvider>
    <Router>
      <Routes>
        <Route path="/candidate-login" element={<CandidateLogin />} />
        <Route path="/client-login" element={<ClientLogin />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/candidate-login/:jobId" element={<CandidateLogin />} />
        <Route path="/email-verification" element={<EmailVerification />} />
        <Route path="/email-verification/:jobId" element={<EmailVerification />} />
        <Route path="/candidate-register" element={<CandidateRegister />} />
        <Route path="/candidate-register/:jobId" element={<CandidateRegister />} />

        {/* Candidate Portal Routes (Protected via Layout) */}
        <Route element={<CandidateLayout />}>
          <Route path="/candidate-dashboard" element={<CandidateDashboard />} />
          <Route path="/applied-jobs" element={<AppliedJobs />} />
          <Route path="/all-jobs" element={<AllJobs />} />
          <Route path="/interview" element={<Interview />} />
          <Route path="/my-jobs" element={<MyJobs />} />
          <Route path="/letters" element={<Letters />} />
          <Route path="/candidate-documents" element={<CandidateDocuments />} />
          <Route path="/candidate-personal-documents" element={<CandidatePersonalDocuments />} />
          <Route path="/agreements" element={<Agreements />} />
          <Route path="/sidebar" element={<Sidebar />} />
          <Route path="/medical-certificate" element={<MedicalCertificate />} />
          <Route path="/saved-jobs" element={<SavedJobs />} />
          <Route path="/jobs/:id" element={<JobDetails />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/my-wallet" element={<CandidateWallet />} />
        </Route>

        {/* Admin / HR Routes (Protected via Layout) */}
        <Route element={<AdminLayout />}>
          <Route path="/recruitment-dashboard" element={<RecruitmentDashboard />} />
          <Route path="/job-post" element={<JobPost />} />
          <Route path="/admin-employee-referral" element={<AdminEmployeeReferral />} />
          <Route path="/job-applicants" element={<JobApplicants />} />
          <Route path="/score" element={<Score />} />
          <Route path="/send-offer" element={<SendOffer />} />
          <Route path="/assessment-manager" element={<AssessmentManager />} />
          <Route path="/personal-documents" element={<PersonalDocuments />} />
          <Route path="/employee-journey" element={<EmployeeJourney />} />
          <Route path="/employee-letters" element={<EmployeeLetters />} />
          <Route path="/employee-resignation" element={<EmployeeResignation />} />
          <Route path="/post-new-job" element={<PostNewJob />} />
          <Route path="/new-assessment" element={<NewAssessment />} />
          <Route path="/selected-candidates" element={<SelectedCandidates />} />
          <Route path="/rejected-candidates" element={<RejectedCandidates />} />
          <Route path="/schedule-interviews" element={<ScheduleInterviews />} />
          <Route path="/job-positions-status" element={<JobPositionsStatus />} />
          <Route path="/acceptance-letter" element={<AcceptanceLetter />} />
          <Route path="/all-medical-certificates" element={<AllMedicalCertificate />} />
          <Route path="/short-jobs" element={<ShortJobs />} />
          <Route path="/posted-short-jobs" element={<PostedShortJobs />} />
          <Route path="/short-job-applicants" element={<ShortJobApplicants />} />
          <Route path="/about-company" element={<AboutCompany />} />
          <Route path="/mywallet" element={<MyWallet />} />
          <Route path="/myreffral" element={<MyReferral />} />
          <Route path="/specialoffers" element={<SpecialOffers />} />
          <Route path="/events" element={<Events />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/adminsidebar" element={<Adminsidebar />} />
          <Route path="/page-access" element={<PageAccess />} />
           <Route path="/attendance-list" element={<Attendancelist />} />
          <Route path="/attendancelist" element={<Attendancelist />} />
        </Route>

        {/* Other Routes */}
        <Route path="/applying-job/:id" element={<ApplyingJob />} />
        <Route path="/take-assessment/:jobId/:applicationId/:quizId" element={<TakeAssessment />} />

        {/* Default / Redirects */}
        <Route path="/" element={<Navigate to="/client-login" replace />} />
        <Route path="*" element={<Navigate to="/client-login" replace />} />
      </Routes>
    </Router>
    <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </ToastProvider>

  );
}

export default App;
